export default {
  industryType: [
    { value: 0, label: '计算机、通信和其他电子设备制造' },
    { value: 1, label: '软件和信息技术服务' },
    { value: 2, label: '信息传输、软件和信息技术服务' },
    { value: 3, label: '互联网和相关服务' },
    { value: 4, label: '科技推广和应用服务业' },
    { value: 5, label: '科学研究和技术服务业' },
    { value: 6, label: '货币金融服务' },
    { value: 7, label: '金融业' },
    { value: 8, label: '商务服务业' },
    { value: 9, label: '租赁和商务服务业' },
    { value: 10, label: '研究和试验发展' },
    { value: 11, label: '教育' },
    { value: 12, label: '零售业' },
    { value: 13, label: '批发业' },
    { value: 14, label: '住宿业' },
    { value: 15, label: '餐饮' },
    { value: 16, label: '文化体育' }
  ],
  oprStatus: [
    {
      label: '存续',
      value: 0
    },
    {
      label: '在业',
      value: 1
    },
    {
      label: '吊销',
      value: 2
    },
    {
      label: '注销',
      value: 3
    },
    {
      label: '迁入',
      value: 4
    },
    {
      label: '迁出',
      value: 5
    },
    {
      label: '停业',
      value: 6
    },
    {
      label: '结算',
      value: 7
    }
  ],
  orgType: [
    { value: 0, label: '国有' },
    { value: 1, label: '集体所有制' },
    { value: 2, label: '私营' },
    { value: 5, label: '企业分支机构' },
    { value: 6, label: '合伙企业' },
    { value: 7, label: '其它企业' },
    { value: 11, label: '股份有限公司（上市、自然人投资或控股）' },
    { value: 12, label: '股份有限公司（非上市、自然人投资或控股）' },
    { value: 21, label: '有限责任公司（法人独资）' },
    { value: 22, label: '有限责任公司（自然人独资）' },
    { value: 23, label: '有限责任公司（自然人投资或控股）' },
    { value: 24, label: '有限责任公司（外国法人独资）' },
    { value: 25, label: '有限责任公司（台港澳和境内合资）' },
    { value: 31, label: '其他股份有限公司（非上市）' },
    { value: 32, label: '其他股份有限公司分公司（非上市）' },
    { value: 33, label: '其他股份有限公司（上市）' },
    { value: 34, label: '其他股份有限公司分公司（上市）' },
    { value: 41, label: '其他有限责任公司' },
    { value: 42, label: '其他有限责任公司分公司' }
  ],
  registerType: [
    { value: 1, label: '有限责任公司' },
    { value: 2, label: '股份有限公司' },
    { value: 3, label: '合伙企业' },
    { value: 4, label: '个人独资' }
  ],
  rentalStatus: [
    { label: '在租', value: 0 },
    { label: '退租', value: 1 },
    { label: '业主', value: 2 },
    { label: '商机', value: 3 }
  ],
  otherRentalStatus: [
    { label: '已签约', value: 0 },
    { label: '退租', value: 1 },
    { label: '意向', value: 2 },
    { label: '储备', value: 3 },
    { label: '待签约', value: 4 }
  ],
  companyLocation: [
    { label: '中关村科学城', value: 1 },
    { label: '怀柔科学城', value: 2 },
    { label: '未来科学城', value: 3 },
    { label: '北京亦庄经济技术开发区', value: 4 }
  ],
  propertyList: [
    { label: '全部', value: '' },
    { label: '主机芯片', value: 1 },
    { label: '存储芯片', value: 2 },
    { label: 'FPGA', value: 3 },
    { label: '数据库', value: 26 },
    { label: '分布式数据库', value: 4 },
    { label: '事务型数据库', value: 5 },
    { label: '中间件', value: 6 },
    { label: '应用软件', value: 7 },
    { label: '网络安全', value: 8 },
    { label: '公有云', value: 9 },
    { label: '私有云', value: 10 },
    { label: '混合云', value: 11 },
    { label: '全栈式架构', value: 12 },
    { label: '外设', value: 13 },
    { label: '整机集成', value: 14 },
    { label: '系统平台', value: 15 },
    { label: '工业互联网', value: 16 },
    { label: '芯片', value: 17 },
    { label: '人工智能', value: 18 },
    { label: 'AI芯片', value: 19 },
    { label: '工控', value: 20 },
    { label: '基础软件', value: 21 },
    { label: '行业软件', value: 22 },
    { label: '办公软件', value: 23 },
    { label: '数字孪生', value: 24 },
    { label: '平台支撑', value: 25 }
  ],
  merchantList: [
    { label: '全部', value: '' },
    { label: '办公', value: 1 },
    { label: '商业', value: 2 }
  ],
  commercialInnovateList: [
    { label: '全部', value: '' },
    { label: '是', value: 1 },
    { label: '否', value: 0 }
  ],
  propertyLists: [
    '全部',
    '主机芯片',
    '存储芯片',
    'FPGA',
    '数据库',
    '分布式数据库',
    '事务型数据库',
    '中间件',
    '应用软件',
    '网络安全',
    '公有云',
    '私有云',
    '混合云',
    '全栈式架构',
    '外设',
    '整机集成',
    '系统平台',
    '工业互联网',
    '芯片',
    '人工智能',
    'AI芯片',
    '工控',
    '基础软件',
    '行业软件',
    '办公软件',
    '数字孪生',
    '平台支撑'
  ],
  merchantLists: ['全部', '办公', '商业'],
  projectStatusList: [
    { label: '全部', value: '' },
    { label: '待启动', value: 0 },
    { label: '进行中', value: 1 },
    { label: '暂停', value: 2 },
    { label: '终止', value: 3 },
    { label: '完成', value: 4 }
  ],
  frequencyList: [
    { label: '空', value: 0 },
    { label: '每周一', value: 1 },
    { label: '每周二', value: 2 },
    { label: '每周三', value: 3 },
    { label: '每周四', value: 4 },
    { label: '每周五', value: 5 },
    { label: '每周六', value: 6 },
    { label: '每周日', value: 7 }
  ],
  tableData: [
    {
      name: '赴园踏勘',
      serialNumber: 1,
      status: 0
    },
    {
      name: '明确意向',
      serialNumber: 2,
      status: 0
    },
    {
      name: '入园申请',
      serialNumber: 3,
      status: 0
    },
    {
      name: '落地方案',
      serialNumber: 4,
      status: 0
    },
    {
      name: '注册',
      serialNumber: 5,
      status: 0
    },
    {
      name: '租赁协议',
      serialNumber: 6,
      status: 0
    },
    {
      name: '产品目录',
      serialNumber: 7,
      status: 0
    },
    {
      name: '装修设计',
      serialNumber: 8,
      status: 0
    },
    {
      name: '完成装修',
      serialNumber: 9,
      status: 0
    },
    {
      name: '入驻',
      serialNumber: 10,
      status: 0
    },
    {
      name: '管委会-上会',
      serialNumber: 11,
      status: 0
    }
  ],
  decorationData: [
    {
      name: '验房',
      serialNumber: 1,
      status: 0
    },
    {
      name: '签订物业协议',
      serialNumber: 2,
      status: 0
    },
    {
      name: '审核施工图纸',
      serialNumber: 3,
      status: 0
    },
    {
      name: '申请装修许可',
      serialNumber: 4,
      status: 0
    },
    {
      name: '取得装修许可',
      serialNumber: 5,
      status: 0
    },
    {
      name: '进场装修',
      serialNumber: 6,
      status: 0
    },
    {
      name: '装修完毕',
      serialNumber: 7,
      status: 0
    },
    {
      name: '申请消电检',
      serialNumber: 8,
      status: 0
    },

    {
      name: '消电检整改',
      serialNumber: 9,
      status: 0
    },
    {
      name: '物业验收',
      serialNumber: 10,
      status: 0
    },
    {
      name: '竣工验收',
      serialNumber: 11,
      status: 0
    },
    {
      name: '入驻办公',
      serialNumber: 12,
      status: 0
    }
  ],
  customStatus: [
    {label: '储备', value: 0},
    {label: '意向', value: 1},
    {label: '待签约', value: 2},
    {label: '已签约', value: 3}
  ],
  approvalStatus: [
    {label: '暂存', value: 0},
    {label: '审批中', value: 1},
    {label: '审批通过', value: 2},
    {label: '暂存', value: 3}
  ],
  typeList: [{
    label: '普通用户',
    value: null
  }, {
    label: '管理员',
    value: 'SUPER_COM_ADMIN'
  }, {
    label: '超级管理员',
    value: 'SUPER_ADMIN'
  }],
  registerSourceList: [{
    value: 0,
    label: '后台创建'
  }, {
    value: 1,
    label: 'APP注册'
  }, {
    value: 2,
    label: '小程序注册'
  }, {
    value: 3,
    label: 'H5注册'
  }],
  landingStatus: [{
    value: 0,
    label: '待审批'
  }, {
    value: 1,
    label: '审批中'
  }, {
    value: 2,
    label: '审批通过'
  }, {
    value: 3,
    label: '审批不通过'
  }]
}



// WEBPACK FOOTER //
// ./src/area-contract/constants/companyConstant.js